/**
 * CART MOTION
 * Two small, independent touches for the cart page and drawer:
 *  1. Fade a line item out the instant its remove button is clicked,
 *     racing alongside Dawn's own fetch + full-section re-render rather
 *     than intercepting it — by the time the real DOM swap lands a few
 *     hundred ms later, the row already reads as gone.
 *  2. Pulse the subtotal once whenever the cart actually changes, so a
 *     quantity edit gives visible feedback instead of a silent number swap.
 */
(function () {
  function onRemoveClick(event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('cart-remove-button, a[href*="quantity=0"], .cart-remove-button');
    if (!trigger) return;
    var row = trigger.closest('tr.cart-item');
    if (row) row.classList.add('candy-removing');
  }
  document.addEventListener('click', onRemoveClick);

  function pulseSubtotals() {
    document.querySelectorAll('.totals__total-value').forEach(function (el) {
      el.classList.remove('candy-pulse-once');
      // Force reflow so re-adding the class restarts the animation even
      // if it fired very recently.
      void el.offsetWidth;
      el.classList.add('candy-pulse-once');
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Wait a tick — the section HTML swap that produces the new
      // .totals__subtotal-value element happens synchronously just before
      // this event is published, but queuing a microtask keeps this safe
      // even if that ordering ever shifts.
      setTimeout(pulseSubtotals, 0);
    });
  }
})();
